import { render, staticRenderFns } from "./EntitlementList.vue?vue&type=template&id=aca24898&scoped=true&"
import script from "./EntitlementList.vue?vue&type=script&lang=js&"
export * from "./EntitlementList.vue?vue&type=script&lang=js&"
import style0 from "./EntitlementList.vue?vue&type=style&index=0&id=aca24898&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca24898",
  null
  
)

export default component.exports